// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LanguageButton_wrapper__FYiut","text":"LanguageButton_text__gZgMo","fa-caret-down":"LanguageButton_fa-caret-down__O6kNP"};